import { Injectable } from '@angular/core';


@Injectable({
    providedIn: 'root',
})
export class FilesizeTransformerService {
    private units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];


    public transform(bytes: number = 0, precision: number = 0): string {
        if (isNaN(parseFloat(String(bytes))) || !isFinite(bytes)) {
            return '?';
        }


        let unit = 0;


        while (bytes >= 1024 && unit < this.units.length - 1) {
            bytes /= 1024;
            unit++;
        }


        if (unit === 2) {
            precision = 1;
        }


        return bytes.toFixed(+precision) + ' ' + this.units[unit];
    }
}